module.exports = __webpack_public_path__ + "img/sign-79.0a0852af.jpg";